// extracted by mini-css-extract-plugin
module.exports = {"switchWrapper":"-switch-switchWrapper--IPNwt-","switchTitle":"-switch-switchTitle-2UvafR-","switchOn":"-switch-switchOn-572veN-","switchOff":"-switch-switchOff-QAX8w_-"};